import { render, staticRenderFns } from "./AppInputFields.vue?vue&type=template&id=5f4b4950&scoped=true&"
import script from "./AppInputFields.vue?vue&type=script&lang=js&"
export * from "./AppInputFields.vue?vue&type=script&lang=js&"
import style0 from "./AppInputFields.vue?vue&type=style&index=0&id=5f4b4950&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../.yarn/__virtual__/vue-loader-virtual-783d792af9/0/cache/vue-loader-npm-15.10.0-778eb54c35-1bf6c9ffea.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4b4950",
  null
  
)

export default component.exports